import { Theme, THEME_DARKMODE } from '@tanium/theme-data';

import { ThemeDefinition } from './useThemeDefinition';

type ThemeDefinitionFactoryParams<T> = [lightModeValue: T, darkModeValue: T];

export type ThemeDefinitionFactory<T> = (
  values: Readonly<ThemeDefinitionFactoryParams<T>>,
) => ThemeDefinition<T>;

/**
 * Create a theme definition
 *
 * @param themeDependentValue A tuple where the first element represents a bluestar value and the second is the dark mode value
 */
const defineThemeValue = <T>([lightModeValue, darkModeValue]: Readonly<
  ThemeDefinitionFactoryParams<T>
>) => (theme: Theme) => {
  // We check for `THEME_DARKMODE` existence here as an extra precaution
  // in case the consumer has not updated their peer dependencies properly
  // and is on a version of `theme-data` that has neither a `THEME_DARKMODE`
  // constant nor a theme `name`.
  return typeof THEME_DARKMODE !== 'undefined' && theme.name === THEME_DARKMODE
    ? darkModeValue
    : lightModeValue;
};

export default defineThemeValue;
